class BannerVideo extends HTMLElement {
  connectedCallback() {
    this.video = this.querySelector('video');
    if (!this.video || this.observer) return;

    // Reduced motion keeps the banner image: never fetch the file at all.
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    // The attribute alone is not enough for autoplay on every browser.
    this.video.muted = true;

    this.observer = new IntersectionObserver(this.handleIntersect.bind(this), {
      rootMargin: '200px 0px',
    });
    this.observer.observe(this);
  }

  disconnectedCallback() {
    if (this.observer) {
      this.observer.disconnect();
      this.observer = null;
    }
  }

  handleIntersect(entries) {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        this.play();
      } else if (!this.video.paused) {
        this.video.pause();
      }
    });
  }

  play() {
    const promise = this.video.play();
    if (typeof promise === 'undefined') {
      this.setAttribute('playing', '');
      return;
    }

    promise
      .then(() => this.setAttribute('playing', ''))
      .catch(() => this.classList.add('banner__video--failed'));
  }
}

if (!customElements.get('banner-video')) {
  customElements.define('banner-video', BannerVideo);
}
